import React from 'react';
import { IconBase } from '../Base';
export const IconExternal = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
            React.createElement("path", { d: "M16 12.8V13.3333C16 14.0406 15.719 14.7189 15.219 15.219C14.7189 15.719 14.0406 16 13.3333 16H6.66667C5.95942 16 5.28115 15.719 4.78105 15.219C4.28095 14.7189 4 14.0406 4 13.3333V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H7.2" }),
            React.createElement("path", { d: "M10 5.5H14.5M14.5 5.5V9.5M14.5 5.5L9 11" }))));
};
//# sourceMappingURL=External.js.map